<template>
	<div class="page-content" style="min-width:1205px;">
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item>智慧服务</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/ServiceReport' }">服务报告</el-breadcrumb-item>
			<el-breadcrumb-item v-if="serviceStep.step !== 3">{{serviceStep.stepText}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div style="min-height: 840px;">
			<flowStep :flowList='flowList' :step='serviceStep.step' class="step-report" v-if="serviceStep.step !== 3"></flowStep>
			<!-- 步骤页面 -->
			<stepOne v-if="serviceStep.step === 0"></stepOne>
			<stepSecond v-if='serviceStep.step === 1' ref='refStepSecond'></stepSecond>
			<stepThird v-if="serviceStep.step === 2"></stepThird>
		</div>
	</div>
</template>
<script>
import flowStep from "components/flowStep/flowStep";
import stepOne from './step1';
import stepSecond from './step2';
import stepThird from './step3';
import { mapGetters, mapActions, mapState } from "vuex";

export default {
	data(){
		return{
			flowList:[
				{info:'选择时间，更新Cookie',sub:'选择报告的数据时间范围，并更新投诉账号Cookie'},
				{info:'预览报告，完善建议',sub:'预览服务报告，并填写完善报告的建议与说明'},
				{info:'完成并下载详情报表',sub:'完成并下载综合的详情报表数据'}
			],
		}
	},
	components:{flowStep,stepOne,stepSecond,stepThird},
	computed: {
		...mapState({
			serviceStep: state => state.serviceReport.serviceStep,
		})
	},
	methods:{
		toSecond(){
			this.$refs.refStepSecond.LinkMonitorshowTable()
		}
	}
}
</script>
<style lang="scss">
.step-report .step-item{
	font-size: 16px;
}
// .el-card {
// 	background-color: #f3f4f5 !important;
// }
// .el-card__body {
// 	padding: 0px !important;
// }
</style>
